import * as yup from "yup";
import { TextFormField } from "../../../../components/textform/TextFormField.tsx";
import { Formik, Field, Form } from "formik";
import moment from "moment";

export const validation = yup.object().shape({
  preparationDateAndTime: yup.string().required("Preparation date is required"),
  messageType: yup.string().required("Message type is required"),
  LRN: yup.string().required("LRN is required"),
  invalidationRequestDateAndTime: yup
    .string()
    .required("Invalidation request date and time is required"),
  invalidationReason: yup.string().required("Invalidation reason is required"),
  customsOfficeOfExportReferenceNumber: yup
    .string()
    .required("Customs office of export reference number is required"),
  exporterIdentificationNumber: yup
    .string()
    .required("Exporter identification number is required"),
  declarantIdentificationNumber: yup
    .string()
    .required("Declarant identification number is required"),
});

export default function IE514({ submitForm, data }) {
  const form = [
    {
      name: "messageSender",
      label: "Message Sender",
      component: TextFormField,
      disabled: true,
      style: {
        width: "32%",
      },
    },
    {
      name: "messageRecipient",
      label: "Message Recipient",
      component: TextFormField,
      disabled: true,
      style: {
        width: "32%",
      },
    },
    {
      name: "preparationDateAndTime",
      label: "Preparation Date and Time",
      component: TextFormField,
      disabled: true,
      style: {
        width: "32%",
      },
    },
    {
      name: "messageIdentification",
      label: "Message Identification",
      component: TextFormField,
      disabled: true,
      style: {
        width: "32%",
      },
    },
    {
      name: "messageType",
      label: "Message Type",
      component: TextFormField,
      disabled: true,
      style: {
        width: "32%",
      },
    },
    {
      name: "appVersion",
      label: "App Version",
      component: TextFormField,
      disabled: true,
      style: {
        width: "32%",
      },
    },
    {
      name: "LRN",
      label: "LRN",
      component: TextFormField,
      disabled: true,
      style: {
        width: "32%",
      },
    },
    {
      name: "invalidationRequestDateAndTime",
      label: "Invalidation Request Date and Time",
      component: TextFormField,
      disabled: false,
      style: {
        width: "32%",
      },
    },
    {
      name: "invalidationReason",
      label: "Invalidation Reason",
      component: TextFormField,
      disabled: false,
      style: {
        width: "32%",
      },
    },
    {
      name: "customsOfficeOfExportReferenceNumber",
      label: "Customs Office of Export Reference Number",
      component: TextFormField,
      disabled: false,
      style: {
        width: "32%",
      },
    },
    {
      name: "exporterIdentificationNumber",
      label: "Exporter Identification Number",
      component: TextFormField,
      disabled: false,
      style: {
        width: "32%",
      },
    },
    {
      name: "declarantIdentificationNumber",
      label: "Declarant Identification Number",
      component: TextFormField,
      disabled: false,
      style: {
        width: "32%",
      },
    },
  ];

  return (
    <div>
      <Formik
        validationSchema={validation}
        initialValues={{
          messageSender: data.message_sender,
          messageRecipient: data.message_recipient,
          preparationDateAndTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
          messageIdentification: data.message_identification,
          messageType: "CC514C",
          appVersion: data.app_version || "0.0.1-SNAPSHOT",
          LRN: data.DECLARATION?.lrn || data.lrn,
          invalidationRequestDateAndTime: moment().format(
            "YYYY-MM-DDTHH:mm:ss"
          ),
          invalidationReason: "",
          customsOfficeOfExportReferenceNumber:
            data.customs_office_reference_number,
          exporterIdentificationNumber:
            data.exporter_identification_number || "",
          declarantIdentificationNumber: data.declarant_identification_number,
        }}
        onSubmit={(values) => {
          submitForm(values);
        }}
      >
        {() => (
          <Form
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              paddingBlock: 50,
            }}
          >
            <div className="form-position">
              {form.map((snapshot, key) => {
                return <Field {...snapshot} key={key} />;
              })}
            </div>
            <button
              style={{
                paddingTop: 10,
                alignSelf: "center",
                width: "35%",
                paddingBlock: 10,
              }}
              className="submit-form"
              type="submit"
            >
              Submit IE514 Declaration
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}
